/**
 * @file: storeFeatureNames.ts
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { StoreFeature } from '@euler/model/enum';

/**
 * Each feature as boss names it to the store, except BI, which the app
 * already calls 经营分析.
 */
export const kStoreFeatureNames: Record<StoreFeature, string> = {
  [StoreFeature.OrderReception]: '手机接单',
  [StoreFeature.PreInspection]: '接车预检',
  [StoreFeature.Inspection]: '车况检查',
  [StoreFeature.Construction]: '施工展示',
  [StoreFeature.DeliveryCheck]: '竣工检验',
  [StoreFeature.SamplingCheck]: '完工抽检',
  [StoreFeature.Quotation]: '电子报价',
  [StoreFeature.MaintenancePlan]: '维保计划',
  [StoreFeature.Lead]: '商机管理',
  [StoreFeature.Reservation]: '预约管理',
  [StoreFeature.Chat]: '聊天',
  [StoreFeature.ChatBot]: 'AI聊天机器人',
  [StoreFeature.ProductReward]: '产品奖励',
  [StoreFeature.RewardsCampaign]: '奖励活动',
  [StoreFeature.CouponCampaign]: '优惠券活动',
  [StoreFeature.Apdm]: '私域营销',
  [StoreFeature.WechatRpa]: '微信客服自动化',
  [StoreFeature.WeworkRpa]: '企业微信客服自动化',
  [StoreFeature.MomentPoster]: '朋友圈海报',
  [StoreFeature.PosterStudio]: '海报工作室',
  [StoreFeature.ErpIntegration]: 'ERP对接',
  [StoreFeature.DailyReport]: '每日晚报',
  [StoreFeature.DataReport]: '数据报告',
  [StoreFeature.MpDataDashboard]: '数据看板',
  [StoreFeature.Bi]: '经营分析',
  [StoreFeature.WorkbenchWeb]: '工作台网页版',
  [StoreFeature.HubDisplay]: '大屏展示',
  [StoreFeature.AiAssistant]: 'AI智能体',
  [StoreFeature.Coaching]: '销售对练',
  [StoreFeature.VoiceInput]: '语音输入',
  [StoreFeature.VoiceSynthesis]: '语音合成',
};
